import { ChangeDetectionStrategy, Component, inject, Injector, input, signal, viewChildren } from '@angular/core';
import { ApprovalFormItem, TextNodeType } from '@mwe/models';
import { ApprovalFormItemComponent } from './approval-form-item.component';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { focusFirstInvalidInput } from '@mwe/utils';

@Component({
  selector: 'mwe-approval-form',
  templateUrl: './approval-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BasicCardComponent, ApprovalFormItemComponent],
})
export class ApprovalFormComponent {
  private readonly injector = inject(Injector);

  readonly items = input.required<ApprovalFormItem[]>();

  readonly itemRefs = viewChildren(ApprovalFormItemComponent);

  readonly isDirty = signal<boolean>(false);
  readonly headlineNodeType = input<TextNodeType>('h5');

  markDirty(): void {
    this.isDirty.set(true);
  }

  isFormItemChecked(id: string): boolean {
    return this.getFormItemRef(id)?.isChecked();
  }

  isValid(): boolean {
    const hasSomeInvalidFormItems = this.itemRefs()?.some(ref => !ref.isValid());
    focusFirstInvalidInput(this.injector);
    return !hasSomeInvalidFormItems;
  }

  private getFormItemRef(id: string): ApprovalFormItemComponent {
    return this.itemRefs()?.find(ref => ref.item().id === id);
  }
}
